@if (operatorStateSrv.loading() && !operatorStateSrv.context()) {
	<main class="loading-state" role="status">
		<img src="/assets/logo_white.png" alt="" style="max-width: 8rem" />
		<p>Φόρτωση καταστήματος…</p>
	</main>
} @else if (operatorStateSrv.loadFailed() || !operatorStateSrv.context()) {
	<main class="loading-state">
		<span class="loading-state__mark">!</span>
		<strong>Δεν φορτώθηκε το κατάστημα</strong>
		<button
			class="button button--accent"
			type="button"
			(click)="operatorStateSrv.initializeContext()"
		>
			Δοκιμή ξανά
		</button>
	</main>
} @else {
	<div class="operator-shell">
		<app-operator-header />
		<router-outlet />
	</div>
}
